import { render, staticRenderFns } from "./DerechosRpc.vue?vue&type=template&id=22b2107b"
import script from "./DerechosRpc.vue?vue&type=script&lang=js"
export * from "./DerechosRpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b2107b')) {
      api.createRecord('22b2107b', component.options)
    } else {
      api.reload('22b2107b', component.options)
    }
    module.hot.accept("./DerechosRpc.vue?vue&type=template&id=22b2107b", function () {
      api.rerender('22b2107b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/DerechosRpc.vue"
export default component.exports